import { UseFieldArrayReturn, useFormContext } from 'react-hook-form';
import { ButtonWithIcon } from 'src/components/Buttons';
import { useAppContext } from 'src/contexts/AppContext';
import { EventMapContextProvider } from 'src/contexts/EventMapContext';
import { vars } from 'src/core/themes';
import { PurchaseTicketGroupHeader } from 'src/modals/PurchaseWizard/PurchaseTicketsFlowV2/PurchaseTicketGroupHeader';
import { PlusIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';

import { MultiplePurchaseVendorHeader } from '../../MultiplePurchaseVendorHeader';
import { PurchaseOrderFormDataType } from '../../MultiplePurchaseWizard';
import { createNewPoValues } from '../../utils/createDefaultValues';
import { PurchaseOrderSection } from './PurchaseOrderSection';

export const PurchaseOrderInput = ({
  fields,
  remove,
  append,
  insert,
}: UseFieldArrayReturn<PurchaseOrderFormDataType, 'purchaseOrders'>) => {
  const { loginContext, activeAccountUserId, activeAccountWebClientConfig } =
    useAppContext();
  const { getValues } = useFormContext<PurchaseOrderFormDataType>();
  const tg = getValues(`purchaseOrders.${0}.ticketGroups`);

  return (
    <EventMapContextProvider
      event={tg[0]?.event || null}
      doNotGetScoreOverrides
    >
      <PurchaseTicketGroupHeader
        ticketGroups={tg}
        isSingleInputModeForMultiEvent={false}
        currentGroupIndex={0}
        groupsOfTicketGroup={[tg]}
      />
      <MultiplePurchaseVendorHeader />
      {fields.map((field, index) => (
        <PurchaseOrderSection
          key={index}
          poIndex={index}
          insert={insert}
          remove={remove}
        />
      ))}
      <ButtonWithIcon
        variant="outline"
        textContentId={ContentId.AddPurchase}
        onClick={() => {
          const newEmptyPo = createNewPoValues({
            activeAccountUserId,
            loginContext,
            prevTicketGroup: tg[0],
          });
          append({ ...newEmptyPo });
        }}
        icon={<PlusIcon size={vars.iconSize.m} />}
      />
    </EventMapContextProvider>
  );
};
